import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addGeneralBilling: build.mutation({
      query: body => ({
        url: '/api/settings/billing/general/add',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useAddGeneralBillingMutation } = extendedApi
